import { useStore } from '@/stores/appStore';
import { SubjectId } from '@/stores/slices/subjectSlice';
import { useMemo, useEffect } from 'react';
import { PaperId } from '@/stores/slices/paperSlice';
import { shallow } from 'zustand/shallow';

export function useSelection(subjectId: SubjectId) {
  const {
    toggleSelected,
    toggleCurrentPageRowsSelected,
    getIsSelected,
    getIsCurrentPageRowsSelected,
    resetRowSelection,
    selectedIdsList,
  } = useStore(state => ({
    toggleSelected: state.toggleSelected,
    toggleCurrentPageRowsSelected: state.toggleCurrentPageRowsSelected,
    getIsSelected: state.getIsSelected,
    getIsCurrentPageRowsSelected: state.getIsCurrentPageRowsSelected,
    resetRowSelection: state.resetRowSelection,
    selectedIdsList: state.selectedIdsList,
  }), shallow);

  const selectedIds = useMemo(() => {
    return Object.keys(selectedIdsList).filter(id => selectedIdsList[id]) as PaperId[];
  }, [selectedIdsList]);

  useEffect(() => {
    resetRowSelection();
  }, [subjectId, resetRowSelection]); // 明确依赖项，确保resetRowSelection稳定

  return {
    toggleSelected,
    toggleCurrentPageRowsSelected,
    getIsSelected,
    getIsCurrentPageRowsSelected,
    selectedIds,
    resetRowSelection,
  };
}

export function useSelectionActions(subjectId: SubjectId) {
  const {
    toggleSelected,
    toggleCurrentPageRowsSelected,
    getIsSelected,
    getIsCurrentPageRowsSelected,
    resetRowSelection,
  } = useStore(state => ({
    toggleSelected: state.toggleSelected,
    toggleCurrentPageRowsSelected: state.toggleCurrentPageRowsSelected,
    getIsSelected: state.getIsSelected,
    getIsCurrentPageRowsSelected: state.getIsCurrentPageRowsSelected,
    resetRowSelection: state.resetRowSelection,
  }), shallow);

  useEffect(() => {
    resetRowSelection();
  }, [subjectId, resetRowSelection]);

  return {
    toggleSelected,
    toggleCurrentPageRowsSelected,
    getIsSelected,
    getIsCurrentPageRowsSelected,
    resetRowSelection,
  };
}
